import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router";
import { ThemeProvider } from "next-themes";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { crearQueryClient } from "./lib/queryClient";

// Ver `lib/queryClient.ts`: el manejo del 401/419 (consultas Y mutaciones)
// vive ahí para poder probarlo sin montar el árbol.
const queryClient = crearQueryClient();

/**
 * Router de DATOS con una única ruta comodín que monta `<App/>`.
 *
 * El árbol de rutas real sigue viviendo en `App.tsx` como `<Routes>`
 * descendientes: acá no se declara ninguna pantalla. Lo único que cambia
 * respecto de `<BrowserRouter>` es la CLASE de router, y eso no es cosmético:
 * `useBlocker` —el único modo soportado de interceptar una navegación para
 * avisar de cambios sin guardar— exige el contexto del data router y lanza si
 * no lo encuentra (`useDataRouterContext("useBlocker")`). Con `BrowserRouter`
 * el aviso solo podría cubrir los enlaces que uno recuerde envolver a mano, y
 * el menú lateral, las migas y el botón "atrás" del navegador quedarían fuera.
 *
 * No se migró el árbol completo a rutas de datos a propósito: eso arrastraría
 * loaders/actions y una reescritura de `App.tsx` que este cambio no necesita.
 */
const router = createBrowserRouter(createRoutesFromElements(<Route path="*" element={<App />} />));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem disableTransitionOnChange>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
